import { indexItems, carouselItems, cardItems, faqItems } from '@/mocks/home';

export function IndexSection() {
  return (
    <section id="index" className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">专题索引</h2>
          <span className="text-xs text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full font-medium">7大专题</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6 hover:border-primary-200 transition-colors group cursor-pointer">
              <div className="flex items-start justify-between mb-3">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading">{item.title}</h3>
                {item.tag && (
                  <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full shrink-0 ml-2 ${
                    item.tag === '热门' ? 'bg-primary-50 text-primary-600' : 'bg-accent-50 text-accent-600'
                  }`}>{item.tag}</span>
                )}
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3">{item.desc}</p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">{item.count}</span>
                <div className="w-6 h-6 flex items-center justify-center text-foreground-400 group-hover:text-primary-500 transition-colors">
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CarouselSection() {
  return (
    <section id="carousel" className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">焦点专题</h2>
          <span className="text-xs text-accent-500 bg-accent-50 px-2 py-0.5 rounded-full font-medium">重磅呈现</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className={`bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors group cursor-pointer ${
                i === 0 ? 'lg:col-span-2' : ''
              } ${i === 1 ? 'lg:col-span-1' : ''}`}
            >
              <div className="relative aspect-[16/9] md:aspect-[21/9] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] md:text-xs font-medium bg-primary-500 text-white px-2 py-0.5 rounded">{item.tag}</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <div className="text-xs text-accent-300 mb-1">{item.subtitle}</div>
                  <h3 className="text-sm md:text-base font-bold text-white font-heading mb-1">{item.title}</h3>
                  <p className="text-xs text-white/70 line-clamp-2 hidden md:block">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function AppSection() {
  return (
    <section id="app" className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">移动端入口</h2>
        </div>

        <div className="bg-gradient-to-r from-primary-600 to-primary-800 rounded-lg p-6 md:p-10 flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h3 className="text-lg md:text-xl font-bold text-white font-heading mb-3">随时随地，畅享国产黑料视频</h3>
            <p className="text-sm text-white/70 leading-relaxed mb-4 md:mb-6 max-w-[480px]">
              17黑料网移动端适配已完成，在手机浏览器中访问即可获得流畅的国产黑料在线观看体验。无需下载安装，打开即用，高清播放不卡顿。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-white/10 text-white text-sm font-medium rounded-md border border-white/20 cursor-pointer hover:bg-white/20 transition-colors whitespace-nowrap">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-smartphone-line"></i>
                </div>
                手机端访问
              </span>
              <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-white text-primary-700 text-sm font-medium rounded-md cursor-pointer hover:bg-white/90 transition-colors whitespace-nowrap">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-qr-scan-line"></i>
                </div>
                扫码直达
              </span>
            </div>
          </div>
          <div className="w-40 h-40 bg-white/10 rounded-lg flex items-center justify-center shrink-0">
            <i className="ri-qr-code-line text-5xl text-white/60"></i>
          </div>
        </div>
      </div>
    </section>
  );
}

export function CardsSection() {
  return (
    <section id="cards" className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">图文资讯</h2>
          <span className="text-xs text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full font-medium">深度内容</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {cardItems.map((item, i) => (
            <div key={i} className={`bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors group cursor-pointer ${
              i === 0 ? 'lg:col-span-2 lg:row-span-1' : ''
            }`}>
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="text-[10px] md:text-xs font-medium bg-primary-500 text-white px-2 py-0.5 rounded">{item.tag}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading mb-2 line-clamp-2 leading-snug">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">{item.desc}</p>
                <span className="text-xs text-foreground-500">{item.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FAQSection() {
  return (
    <section id="faq" className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">常见问答</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {faqItems.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading mb-3 flex items-start gap-2">
                <span className="text-primary-500 font-bold shrink-0">Q{i + 1}.</span>
                {item.q}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed pl-5 md:pl-6">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}